import { A as DA, useSx } from 'dripsy';
import React from 'react';
import { LNTextProps } from './h3';

export function A({ style: styles, ...props }: LNTextProps) {
  const sx = useSx();

  return <DA style={[sx({}), styles]} {...props} />;
}
